import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import FlatLayout from 'components/Layout/FlatLayout';
import HighlightedStores from 'components/Sidebar/HighlightedStores/V2';

import BestCoupons from './BestCoupons';
import RelatedStores from './RelatedStores';
import StoreDetails from './StoreDetails';
import StoreFaq from './StoreFaq';

import {
  BEST_COUPON_STORES,
  HIGHLIGHTED_STORES,
  getRelatedStores,
} from 'constants/couponSidebar';

const StoreChecklist = dynamic(() => import('./StoreChecklist'));

const StoreSidebar = ({
  gaEventCategory,
  hasPhysicalStore,
  isCnpjValid,
  isOfferPage = false,
  isStoreChecklistActive = true,
  isVerified,
  storeAddress,
  storeContacts,
  storeDescription,
  storeDomain,
  storeDomainEnriched,
  storeFacebookPage,
  storeName,
  storeRating,
  storeRatingCount,
  storeSlug,
}) => (
  <FlatLayout.Sidebar>
    <StoreDetails
      gaEventCategory={gaEventCategory}
      storeAddress={storeAddress}
      storeContacts={storeContacts}
      storeDescription={storeDescription}
      storeDomain={storeDomain}
      storeDomainEnriched={storeDomainEnriched}
      storeFacebookPage={storeFacebookPage}
      storeName={storeName}
      storeRating={storeRating}
      storeRatingCount={storeRatingCount}
      storeSlug={storeSlug}
    />
    {isStoreChecklistActive && (
      <StoreChecklist
        hasPhysicalStore={hasPhysicalStore}
        isCnpjValid={isCnpjValid}
        isVerified={isVerified}
        storeName={storeName}
      />
    )}
    {!isOfferPage && (
      <>
        <BestCoupons stores={BEST_COUPON_STORES} />
        <StoreFaq storeName={storeName} />
        <RelatedStores
          storeName={storeName}
          storeSlug={storeSlug}
          stores={getRelatedStores(storeSlug)}
        />
      </>
    )}
    <HighlightedStores stores={HIGHLIGHTED_STORES} />
  </FlatLayout.Sidebar>
);

StoreSidebar.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  hasPhysicalStore: PropTypes.bool,
  isCnpjValid: PropTypes.bool,
  isOfferPage: PropTypes.bool,
  isStoreChecklistActive: PropTypes.bool,
  isVerified: PropTypes.bool.isRequired,
  storeAddress: PropTypes.string,
  storeContacts: PropTypes.string,
  storeDescription: PropTypes.string,
  storeDomain: PropTypes.string.isRequired,
  storeDomainEnriched: PropTypes.string,
  storeFacebookPage: PropTypes.string,
  storeName: PropTypes.string.isRequired,
  storeRating: PropTypes.number,
  storeRatingCount: PropTypes.number,
  storeSlug: PropTypes.string.isRequired,
};

export default StoreSidebar;
